let audioContext;

const getAudioContext = () => {
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return null;
  if (!audioContext) audioContext = new AudioContextClass();
  return audioContext;
};

const playTone = (frequency, startTime, duration, gainValue = 0.022, type = 'sine') => {
  const ctx = getAudioContext();
  if (!ctx) return;

  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startTime);
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(gainValue, startTime + 0.018);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);

  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration + 0.02);
};

export const playNotificationSound = (type = 'default') => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const now = ctx.currentTime;

    if (type === 'success') {
      playTone(523.25, now, 0.075, 0.018, 'sine');
      playTone(659.25, now + 0.065, 0.085, 0.018, 'sine');
      playTone(783.99, now + 0.135, 0.11, 0.016, 'sine');
      return;
    }

    if (type === 'error') {
      playTone(392, now, 0.09, 0.018, 'triangle');
      playTone(293.66, now + 0.085, 0.11, 0.016, 'triangle');
      return;
    }

    if (type === 'warning') {
      playTone(440, now, 0.075, 0.017, 'sine');
      playTone(554.37, now + 0.075, 0.095, 0.016, 'sine');
      return;
    }

    playTone(587.33, now, 0.075, 0.014, 'sine');
  } catch {
    // Browser audio can be blocked before user interaction; ignore silently.
  }
};
